export default function() {
  return new Worker(__webpack_public_path__ + "js/7ea84ff70bf5805fec05-worker.worker.js");
}
